export default __webpack_public_path__ + "static/media/IOT.7eebf732.svg";